import React__default from 'react';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.es.js';

const root = "_root_1r8l6_1";
const spin = "_spin_1r8l6_1";
const styles = {
	root: root,
	spin: spin
};

const Spinner = ({ "aria-label": ariaLabel = "Loading", color = "dark", size = "small" }) => {
  return React__default.createElement(
    "div",
    { className: styles.root, "data-testid": "spinner", role: "status", "data-zds": true, "data-color": color, "data-size": size },
    React__default.createElement(VisuallyHidden, null, ariaLabel)
  );
};

export { Spinner };
//# sourceMappingURL=Spinner.es.js.map
